// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__ENCYH","paramInput":"JobSimulator_paramInput__2GOZw","input":"JobSimulator_input__fUJBF"};